import "rc-slider/assets/index.css";
import "./DbrdReplay.scss";

import React, { Component } from "react";

import { AVIDashboard } from "../../chart-components/Layout/AVIDashboard";
import { CBoxMenu } from "../../chart-components/Charts/CBoxMenu";
import { DashboardConfig } from "../../config/kyvDashboard";
import { DataLoader } from "../../ui-components/DataLoader/DataLoader";
import { FilterToFromTime } from "../../filters/FilterToFromTime";
import { Loader } from "../../ui-components/Loader/Loader";
import { NoData } from "../../ui-components/NoData/NoData";
import { PosUtils } from "../../chart-components/ChartUtils/PosUtils";
import PropTypes from "prop-types";
import { ReplayMapChart } from "../../chart-components/ChartsExt/ReplayMapChart";
import TimeLine from "./../../chart-components/TimeLine/TimeLine";
import { TimeUtils } from "../../chart-components/ChartUtils/TimeUtils";
import crossfilter from "crossfilter2";
import olWKT from "ol/format/WKT";
import { AVIRow } from "./../../chart-components/Layout/AVIRow";
import { AVICol } from "./../../chart-components/Layout/AVICol";
import withRouter from "../../hocs/withRouter";

class DbrdReplayBase extends Component {
  static dashboardRoute = "sporing";

  static dashboardFilters(filter, setFilter) {
    return {
      helpMessage:
        "Sporing av seilas innen et område genererer svært mye data. Det er ment benyttet for korte tidsrom og for små områder for å analysere hendelsesforløp. I områder med høy trafikk kan man velge inntil en dag om gangen; i områder med lav trafikk kan man velge inntil en 3 dager eller mer. Prøv deg frem. Gå tilbake og begrens utvalget hvis fremdriftsindikatoren blir stående å spinne på skjermen lenge.  Tidspunkt i dataene er angitt som UTC.",
      controls: (
        <FilterToFromTime
          key="flt"
          firstYear={2013}
          filter={filter}
          setFilter={setFilter}
        />
      ),
    };
  }

  static dashboardSettings() {
    return {
      filterControls: [
        DashboardConfig.filterControls.drawBox,
        DashboardConfig.filterControls.drawPolygon,
      ],
      selectableLayer: null,
    };
  }

  static dashboardValidation(filter) {
    if (filter.fromTime && filter.toTime && filter.geom) {
      return true;
    }
  }

  static propTypes = {
    location: PropTypes.object,
  };

  timeout = null;

  constructor(props) {
    super(props);

    const { fromTime, toTime } = this.props.location.state;

    // Initialize properties
    this.startTime = new Date(fromTime);
    this.endTime = new Date(toTime);
    this.animationRange = (this.endTime - this.startTime) / 1000;
    this.currentAnimationFrame = 0;
    this.currentTime = new Date(this.startTime);

    // Set initial state
    this.state = {
      timeSeries: null,
      start: this.startTime,
      end: this.endTime,
      span: (this.endTime - this.startTime) / 1000,
    };

    // Bind functions to current scope
    this.reportProgress = this.reportProgress.bind(this);
    this.setGeoJson = this.setGeoJson.bind(this);
    this.download = this.download.bind(this);
  }

  reportProgress(progressData) {
    this.setState({
      progressData: progressData,
    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  componentDidMount() {
    const { geom, fromTime, toTime } = this.props.location.state;

    var startTime = TimeUtils.toTimestamp(new Date(fromTime));
    var endTime = TimeUtils.toTimestamp(new Date(toTime));

    // var bboxGeom = null;
    var bbox = null;
    if (Array.isArray(geom) && geom.length === 1) {
      bbox = new olWKT().readFeature(geom[0]).getGeometry().getExtent();
      // bboxGeom = bbox.join(",");
    }

    if (geom && startTime && endTime) {
      DataLoader.post(
        process.env.REACT_APP_DASHBOARD_WS_API +
          "/api/ais/positions/within-geom-time",
        {
          geom: geom[0],
          start: new Date(fromTime),
          end: new Date(toTime),
        },
        this.reportProgress
      ).then(
        (posInfo) => {
          if (Array.isArray(posInfo.data) && posInfo.data.length > 0) {
          } else {
            console.error("Failed, posInfo is not an array or is empty");
            return;
          }

          var uniqueMmsis = [];
          posInfo.data.forEach((pos) => {
            if (uniqueMmsis.indexOf(pos[0]) === -1) {
              uniqueMmsis.push(pos[0]);
            }
          });
          DataLoader.post(
            process.env.REACT_APP_DASHBOARD_WS_API +
              "/api/ais/statinfo/for-mmsis-time",
            {
              MmsiIds: uniqueMmsis,
              Start: startTime,
              End: endTime,
            },
            this.reportProgress
          ).then((statInfo) => {
            var timeSeries = PosUtils.createTimeSeries(
              posInfo.data,
              statInfo.data
            );

            if (timeSeries.length > 0) {
              var firstPos = timeSeries.map((d) => {
                return d.positions[0][1];
              });
              if (firstPos.length > 0) {
                this.currentTime = firstPos.sort(TimeUtils.dateSort)[0];
                this.currentAnimationFrame =
                  (this.currentTime - this.startTime) / 1000;
              }
            }

            this.setState({
              timeSeries: timeSeries,
              chartData: crossfilter(timeSeries),
              bbox: bbox,
            });
          });
        },
        (error) => {
          if (error) {
            console.error("Error occurred");
          }
        }
      );
    } else {
      console.warn("No selection parameters specified");
    }
  }

  setGeoJson(geoJsonData) {
    this.setState({
      geoJson: geoJsonData.positions,
      trackGeoJson: geoJsonData.tracks,
    });
  }

  download() {
    const { chartData } = this.state;

    const sep = ";";

    var fileData = [
      ["lat", "lng", "date_time_utc", "name", "mmsi", "imo", "callsign"].join(
        sep
      ),
    ];
    chartData.all().forEach((ship) => {
      ship.positions.forEach((pos) => {
        fileData.push(
          [
            pos[2],
            pos[3],
            pos[1].toJSON(),
            `"${ship.name}"`,
            ship.mmsi,
            ship.imo_num,
            `"${ship.callsign}"`,
          ].join(sep)
        );
      });
    });

    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(fileData.join("\r\n"))
    );
    element.setAttribute("download", "points.csv");

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  render() {
    const { chartData, geoJson, trackGeoJson, progressData, bbox } = this.state;
    const { fromTime, toTime } = this.props.location.state;
    if (!chartData) {
      return <Loader progressData={progressData} chartData={chartData} />;
    }

    if (chartData.size() < 1) {
      return <NoData history={History} />;
    }

    var dimCount = chartData.dimension((d) => {
      return d.mmsi + " - " + (d.name || "Ukjent navn");
    });

    var segmentsPerShip = dimCount.group().reduceCount();

    return (
      <div className="AppView">
        <AVIDashboard
          title="Skipstrafikk"
          desc={
            "Vis skipstrafikk i tidsrommet fra " +
            TimeUtils.formatTimeUTC(this.startTime) +
            " til " +
            TimeUtils.formatTimeUTC(this.endTime) +
            ". Alle tidspunkt er angitt i UTC"
          }
          group={dimCount.groupAll()}
          units="Gjennomseilinger"
          spacing={20}
          useFlex
        >
          <AVIRow>
            <CBoxMenu
              chartTitle="Avgrens til skip/mmsi nummer"
              width={4}
              height={0.5}
              dimension={dimCount}
              group={segmentsPerShip}
              multiple
              filterPrefix="Skip"
              useFlex
            />
          </AVIRow>
          <AVIRow>
            <TimeLine
              fromTime={fromTime}
              toTime={toTime}
              chartData={chartData}
              setGeoJson={this.setGeoJson}
              startTime={this.currentTime}
            />
          </AVIRow>
          <AVIRow style={{ height: "75vh" }}>
            <ReplayMapChart
              allowFullscreen={true}
              chartTitle="Kartvisning"
              bbox={bbox}
              geoJson={geoJson}
              trackGeoJson={trackGeoJson}
              height={2.5}
              width={4}
              labelProperty="mmsi"
              colorProperty="mmsi"
              useFlex
            />
          </AVIRow>
          <AVIRow>
            <AVICol>
              <button onClick={this.download}>
                Last ned punktdata med tidsstempel for videre analyse
              </button>
            </AVICol>
          </AVIRow>
        </AVIDashboard>
      </div>
    );
  }
}

export const DbrdReplay = withRouter(DbrdReplayBase);

export default DbrdReplay;
